import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantService } from '@app/core/tenant/tenant.service';
import { environment } from '@app/environments/environment';

@Component({
  selector: 'app-footer',

  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  tenant = inject(TenantService);
  year = new Date().getFullYear();
  public readonly footerImageUrl: string = `${environment.TENANT_CDN_BASE_URL}/assets/CardCentralLogo.png`;
}
